import styled from 'styled-components/macro';
import {MenuItem} from "@chakra-ui/react";
import NavLink from "./nav_link";
import {
    Clock,
    MessageCircle,
    Rocket,
    TrendingUp,
    ArrowUpWideNarrow,
    Infinity,
    CalendarCheck,
    Calendar, Zap
} from "lucide-react";

const DesktopFeedSortMenu = styled(({className, sort, community}) => {
    const baseUrl = community !== "home" ? `/c/${community.toLowerCase()}/` : "/";
    return (
        <div className={className}>
            <NavLink href={`${baseUrl}`} react_route>
                <MenuItem minH='40px'>
                    <Rocket size={18} />
                    <span>Hot</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`${baseUrl}active`} react_route>
                <MenuItem minH='40px'>
                    <MessageCircle size={18} />
                    <span>Active</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`${baseUrl}new`} react_route>
                <MenuItem minH='40px'>
                    <Clock size={18} />
                    <span>New</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`${baseUrl}rising`} react_route>
                <MenuItem minH='40px'>
                    <TrendingUp size={18} />
                    <span>Rising</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`${baseUrl}top`} react_route>
                <MenuItem minH='40px'>
                    <ArrowUpWideNarrow size={18} />
                    <span>Top</span>
                </MenuItem>
            </NavLink>
        </div>
    );
})`
  svg {
    margin: 0 16px 0 8px;
  }
`;

const topPath = (community, top) => {
    return community && community !== 'home' ? `/c/${community}/top?sort=${top}` : `/top?sort=${top}`;
}

export const DesktopFeedTopSortMenu = styled(({className, timeFrame, community}) => {
    return (
        <div className={className}>
            <NavLink href={topPath(community, 'hour')} react_route>
                <MenuItem minH='40px'>
                    <Zap size={18} />
                    <span>Hourly</span>
                </MenuItem>
            </NavLink>
            <NavLink href={topPath(community, 'day')} react_route>
                <MenuItem minH='40px'>
                    <Clock size={18} />
                    <span>Daily</span>
                </MenuItem>
            </NavLink>
            <NavLink href={topPath(community, 'week')} react_route>
                <MenuItem minH='40px'>
                    <Calendar size={18} />
                    <span>Weekly</span>
                </MenuItem>
            </NavLink>
            <NavLink href={topPath(community, 'month')} react_route>
                <MenuItem minH='40px'>
                    <CalendarCheck size={18} />
                    <span>Monthly</span>
                </MenuItem>
            </NavLink>
            <NavLink href={topPath(community, 'all')} react_route>
                <MenuItem minH='40px'>
                    <Infinity size={18} />
                    <span>All-time</span>
                </MenuItem>
            </NavLink>
        </div>
    );
})`
  svg {
    margin: 0 16px 0 8px;
  }
`;

export default DesktopFeedSortMenu;
